import { render, staticRenderFns } from "./orderStatusBadge.vue?vue&type=template&id=427a3c2c&scoped=true"
import script from "./orderStatusBadge.vue?vue&type=script&lang=js"
export * from "./orderStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./orderStatusBadge.vue?vue&type=style&index=0&id=427a3c2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427a3c2c",
  null
  
)

export default component.exports